<template lang="pug">
  .level-two-data
    .relationship-table
      relationship-block(v-if="showParents" title="Parents", root-class="parents-block")
        .parents(v-if="parentsAreExist")
          lei-link.parent(v-if="available"
          v-for="({parent, name, info, exception, subInfo, tip, available}, i) in parents", :key="i",
          :to="parent ? {name: 'RecordDetailsPage', params: {id: parent.id}} : {}", :tip="tip",
          @more="showMore({show: true, parent, exception, info})"
          :custom-color="handleRelationshipStatus(subInfo, 'Parent', parent ? parent.id : null)")
            p {{name}}
            p.exception(slot="link" v-if="exception") {{name}}
            p(slot="append") ({{subInfo}})
          p.n-a(v-else) {{`${name} (${subInfo})`}}
        .empty(v-else)
          p.info No parent data available for {{companyName}}
      relationship-block(
        v-if="showChildren"
        :title="`Direct children (${directChildrenCount})`",
        root-class="children-block", :tooltip="tooltips.l2DirectChildren" :is-children="true")
        .children(v-if="directChildrenCount !== 0")
          p.name {{companyName}}
          child-link(v-for="(child, i) in directChildren", :key="i", :child="child", :parent="record")
        .empty(v-else)
          p.info No direct child data available for {{companyName}}
        lei-popover()
          show-more(v-if="showDirectChildrenMoreBtn", @show-more="showMorePages({type: 'direct-children'})")
      relationship-block(
        v-if="showChildren"
        :title="`Ultimate children (${ultimateChildrenCount})`",
        root-class="children-block", :tooltip="tooltips.l2UltimateChildren" :is-children="true")
        .children(v-if="ultimateChildrenCount !== 0")
          lei-link.ultimate-child(
          v-for="(child, i) in ultimateChildren", :key="i",
          :to="{name: 'RecordDetailsPage', params: {id: child.id}}",
          :with-challenge="true"
          @more="showUltimateChildrenRelationship(child)"
          :custom-color="handleRelationshipStatus('Ultimate', 'Child', child.id)")
            p {{child.entity.legalName.name}}
            p(slot="append") (Ultimate)
        .empty(v-else)
          p.info No ultimate child data available for {{companyName}}
        lei-popover()
          show-more(v-if="showUltimateChildrenMoreBtn", @show-more="showMorePages({type: 'ultimate-children'})")


      relationship-block(
        v-if="showBranchRelationship"
        :title="`Head Office`",
        root-class="parents-block", :is-children="true")
        .parents(v-if="headOffice")
          lei-link.parent(
            :to="{name: 'RecordDetailsPage', params: {id: headOffice.id}}",
            :with-challenge="true"
            @more="showEntityRelationship({entity: headOffice, type:'head-office-relationship', parent: true})"
            :custom-color="handleRelationshipStatus('Head', 'Branch', headOffice ? headOffice.id : null)")
            p {{headOffice.entity.legalName.name || headOffice.id}}
            p(slot="append") (Head office)
        .empty(v-else)
          p.info No head office data available for {{companyName}}

      relationship-block(
        v-if="showBranchRelationship"
        :title="`Branches (${branchesCount})`",
        root-class="children-block", :is-children="true")
        .children(v-if="branchesCount !== 0")
          lei-link.ultimate-child(
            v-for="(branch, i) in branches", :key="i",
            :to="{name: 'RecordDetailsPage', params: {id: branch.id}}",
            :with-challenge="true"
            @more="showEntityRelationship({entity: branch, type:'head-office-relationship'})"
            :custom-color="handleRelationshipStatus('Branch', 'Branch', branch.id)")
            p {{branch.entity.legalName.name || branch.id}}
            p(slot="append") (Branch)
        .empty(v-else)
          p.info No branches data available for {{companyName}}
        lei-popover()
          show-more(v-if="showBranchesMoreBtn", @show-more="showMorePages({type: 'branches'})")

      .fund-block(
        v-if="showFundRelationship",
        v-for="({groupTitle, relationships, groupAvailable}, i) in getFunds",
        :key="i + groupTitle",
      )
        .group-name {{groupTitle}}
        div(v-if="groupAvailable",)
          relationship-block(
            v-for="({title, funds, count, showMore, relationshipMoreURL, parent, subInfo}, i) in relationships",
            :key="i + title"
            :title="`${title} ${count}`",
            root-class="children-block", :is-children="true")
            .children(v-if="funds.length !== 0")
              lei-link.ultimate-child(
                v-for="(fund, i) in funds", :key="i",
                :to="{name: 'RecordDetailsPage', params: {id: fund.id}}",
                @more="showEntityRelationship({entity:fund, type:relationshipMoreURL, parent})"
                :custom-color="handleRelationshipStatus(title, 'Fund', fund.id)")
                p {{fund.entity.legalName.name || fund.id}}
                p(slot="append") ({{subInfo}})
            .empty(v-else)
              p.info No {{title}} data available for {{companyName}}
            lei-popover()
              show-more(v-if="showMore", @show-more="showMorePages({type: title.toLowerCase().replace(' ', '-')})")
        .content-empty(v-else)
          p.info No {{groupTitle}} data available for {{companyName}}

</template>
<script>
import { mapActions, mapGetters, mapMutations, mapState, } from 'vuex'
import LeiLink from '../lei-components/LeiLink'
import Graph from '../record-details/Graph'
import { TOGGLE_RELATIONSHIP_MODAL, TOGGLE_DISPLAY_SECTION, } from '../../store/modules/record/mutations-types'
import { parseRecord, } from '../../store/modules/record/helpers/parsing'
import ChildLink from './ChildLink'
import LeiBtn from '../lei-components/LeiBtn'
import ShowMore from './ShowMore'
import LeiPopover from '../lei-components/LeiPopover'
import record from '../../constants/tooltips/record'
import RelationshipBlock from './RelationshipBlock'

export default {
  components: {
    RelationshipBlock,
    ShowMore,
    LeiBtn,
    ChildLink,
    LeiLink,
    Graph,
    LeiPopover,
  },
  props: {
    title: {
      type: String,
      required: true,
    },
  },
  data () {
    return {
      morePages: {
        'managed-funds': 1,
        'sub-funds': 1,
        'feeder-funds': 1,
        'branches': 1,
        'direct-children': 1,
        'ultimate-children': 1,
      },
      tooltips: record,
      showFundRelationshipModal: false,
    }
  },

  computed: {
    showParents () {
      return this.title === 'Parents'
    },
    showChildren () {
      return this.title === 'Children'
    },
    showFundRelationship () {
      return this.title === 'Fund Relationships'
    },
    showBranchRelationship () {
      return this.title === 'Branch Relationships'
    },

    getFunds () {
      return [
        {
          groupTitle: 'Fund Management Relationships',
          groupAvailable: !!this.fundManager || (this.managedFundsCount !== 0),
          relationships: [
            {
              title: 'Fund Manager',
              relationshipMoreURL: 'fund-manager-relationship',
              subInfo: 'Fund Management Entity',
              parent: true,
              count: '',
              showMore: false,
              funds: this.fundManager ? [ this.fundManager, ] : [],
            },
            {
              title: 'Managed Funds',
              relationshipURL: 'managed-fund-relationships',
              relationshipMoreURL: 'fund-manager-relationship',
              subInfo: 'Managed Fund',
              parent: false,
              count: `(${this.managedFundsCount})`,
              showMore: this.showManagedFundsMoreBtn,
              funds: [ ...this.managedFunds, ],
            },
          ],
        },
        {
          groupTitle: 'Master-Feeder Relationships',
          groupAvailable: !!this.masterFund || (this.feederFundsCount !== 0),
          relationships: [
            {
              title: 'Master Fund',
              relationshipMoreURL: 'master-fund-relationship',
              parent: true,
              subInfo: 'Master Fund',
              count: '',
              showMore: false,
              funds: this.masterFund ? [ this.masterFund, ] : [],
            },
            {
              title: 'Feeder Funds',
              relationshipURL: 'feeder-fund-relationships',
              relationshipMoreURL: 'master-fund-relationship',
              parent: false,
              subInfo: 'Feeder Fund',
              count: `(${this.feederFundsCount})`,
              showMore: this.showFeederFundsMoreBtn,
              funds: [ ...this.feederFunds, ],
            },
          ],
        },
        {
          groupTitle: 'Umbrella Structure Relationships',
          groupAvailable: !!this.umbrellaFund || (this.subFundsCount !== 0),
          relationships: [
            {
              title: 'Umbrella Fund',
              relationshipMoreURL: 'umbrella-fund-relationship',
              parent: true,
              count: '',
              subInfo: 'Umbrella Structure',
              showMore: false,
              funds: this.umbrellaFund ? [ this.umbrellaFund, ] : [],
            },
            {
              title: 'Sub Funds',
              relationshipURL: 'sub-fund-relationships',
              relationshipMoreURL: 'umbrella-fund-relationship',
              parent: false,
              subInfo: 'Sub-Fund / Compartment',
              count: `(${this.subFundsCount})`,
              showMore: this.showSubFundsMoreBtn,
              funds: [ ...this.subFunds, ],
            },
          ],
        },
      ]
    },

    ...mapState('record', [
      'record',
      'directChildren',
      'ultimateChildren',
      'showUltimateChildrenMoreBtn',
      'showDirectChildrenMoreBtn',
      'directChildrenCount',
      'ultimateChildrenCount',
      'ultimateChildrenRelationships',
      'directChildrenRelationships',
      'directParentRelationship',
      'ultimateParentRelationship',
      'headOfficeRelationship',
      'branchesRelationships',
      'fundManagerRelationship',
      'managedFundsRelationships',
      'umbrellaFundRelationship',
      'subFundsRelationships',
      'masterFundRelationship',
      'feederFundsRelationships',
      'headOffice',
      'branches',
      'fundManager',
      'managedFunds',
      'umbrellaFund',
      'subFunds',
      'masterFund',
      'feederFunds',
      'branchesCount',
      'managedFundsCount',
      'subFundsCount',
      'feederFundsCount',
      'showBranchesMoreBtn',
      'showManagedFundsMoreBtn',
      'showSubFundsMoreBtn',
      'showFeederFundsMoreBtn',
    ]),
    ...mapGetters('record', [ 'companyName', 'parents', 'parentsAreExist', ]),
  },
  created () {
    if (this.showChildren) this.getChildrenRelationships()
    if (this.showBranchRelationship){
      if (this.branchesCount !== 0 || !!this.headOffice) {
        if (this.branchesCount !== 0) this.getRelationshipsByType({ type: 'branch-relationships', })
        this.toggleDisplaySection({
          property: 'showLevelTwoBranches',
          value: true,
        })
      } else {
        this.toggleDisplaySection({
          property: 'showLevelTwoBranches',
          value: false,
        })
      }
    }
    if (this.showFundRelationship){
      if (this.getFunds.some((fund) => fund.groupAvailable)) {
        this.getFunds.map((fund) => {
          if (fund.groupAvailable) fund.relationships.map((rel) => {
            if (rel.funds.length > 0 && !!rel.relationshipURL) {
              this.getRelationshipsByType({ type: rel.relationshipURL, })
            }
          })
        })
        this.toggleDisplaySection({
          property: 'showLevelTwoFunds',
          value: true,
        })
      } else {
        this.toggleDisplaySection({
          property: 'showLevelTwoFunds',
          value: false,
        })
      }
    }
  },

  methods: {
    showEntityRelationship ({ entity, type, parent = false, }) {
      this.getRelationships({
        id: parent ? this.record.id : entity.id,
        type,
        cb: ({ data, }) => {
          this.getEntitiesLeiIssuer({
            id: entity.id,
            registration: data.attributes.registration,
          })
            .then(() => {
              this.showMore({
                show: true,
                child: parent ? this.record : entity,
                parent: parent ? entity : this.record,
                info: parseRecord(data),
              })
            })
        },
      })
    },
    showUltimateChildrenRelationship (child) {
      this.getRelationships({
        id: child.id,
        type: 'ultimate-parent-relationship',
        cb: ({ data, }) => {
          this.getEntitiesLeiIssuer({
            id: child.id,
            registration: data.attributes.registration,
          })
            .then(() => {
              this.showMore({
                show: true,
                child,
                parent: this.record,
                info: parseRecord(data),
              })
            })
        },
      })
    },
    showRecordDetails (id) {
      this.$router.push({
        name: 'RecordDetailsPage',
        params: { id: id, },
      })
    },
    showMorePages ({ type, }) {
      this.morePages[type]++
      this.getChildren({
        id: this.record.id,
        page: this.morePages[type],
        type,
      })
    },
    getRelationshipsByType ({ type, }) {
      this.getFullRelationships({
        id: this.record.id,
        queryType: type,
      })
    },
    getChildrenRelationships () {
      if (this.directChildrenCount && this.showChildren) {
        this.getFullRelationships({
          id: this.record.id,
          queryType: 'direct-child-relationships',
        })
      }
      if (this.ultimateChildrenCount && this.showChildren) {
        this.getFullRelationships({
          id: this.record.id,
          queryType: 'ultimate-child-relationships',
        })
      }
    },
    handleRelationshipStatus (type, nodeType, id) {
      if (nodeType === 'Child') {
        if (type === 'Ultimate') {
          for (const element of this.ultimateChildrenRelationships) {
            if (element.attributes.relationship.startNode.id === id) {
              return element.attributes.registration.status
            }
          }
        } else {
          for (const element of this.directChildrenRelationships) {
            if (element.attributes.relationship.startNode.id === id) {
              return element.attributes.registration.status
            }
          }
        }
      } else if (!!id && nodeType === 'Parent') {
        return type === 'Ultimate Parent' ?
          this.ultimateParentRelationship.registration.status :
          this.directParentRelationship.registration.status
      } else if (nodeType === 'Branch') {
        if (type === 'Head' && !!this.headOfficeRelationship) return this.headOfficeRelationship.registration.status
        if (type === 'Branch') {
          for (const element of this.branchesRelationships) {
            if (element.attributes.relationship.startNode.id === id) {
              return element.attributes.registration.status
            }
          }
        }
      } else if (nodeType === 'Fund') {
        if (type === 'Fund Manager' && !!this.fundManagerRelationship) return this.fundManagerRelationship.registration.status
        if (type === 'Master Fund' && !!this.masterFundRelationship) return this.masterFundRelationship.registration.status
        if (type === 'Umbrella Fund' && !!this.umbrellaFundRelationship) return this.umbrellaFundRelationship.registration.status
        if (type === 'Managed Funds') {
          for (const element of this.managedFundsRelationships) {
            if (element.attributes.relationship.startNode.id === id) {
              return element.attributes.registration.status
            }
          }
        }
        if (type === 'Feeder Funds') {
          for (const element of this.feederFundsRelationships) {
            if (element.attributes.relationship.startNode.id === id) {
              return element.attributes.registration.status
            }
          }
        }
        if (type === 'Sub Funds') {
          for (const element of this.subFundsRelationships) {
            if (element.attributes.relationship.startNode.id === id) {
              return element.attributes.registration.status
            }
          }
        }
      }
      return ''
    },
    ...mapMutations('record', {
      showMore: TOGGLE_RELATIONSHIP_MODAL,
      toggleDisplaySection: TOGGLE_DISPLAY_SECTION,
    }),
    ...mapActions('record', [
      'getChildren',
      'getRelationships',
      'getEntitiesLeiIssuer',
      'getFullRelationships',
    ]),
  },
}
</script>
<style lang="stylus" scoped>
  @import "../../assets/styles/variables.styl"
  .empty
    color $default-color-middle

  .content-empty
    color $default-color-middle
    padding 30px 20px
    background-color $default-color-light-2

  .fund-empty
    color $default-color-middle
    width: 50%
    align-self flex-start


  .lapsed
    text-decoration: underline #CD5C5C
    text-underline-offset: 3px
    text-decoration-thickness: 2px

  .published
    text-decoration: underline #4682B4
    text-underline-offset: 3px
    text-decoration-thickness: 2px

  .relationship-table
    font-size 95%

    .parents
      display flex

    .parent, .n-a
      flex 1
      color $default-color-bold

    .funds
      background-color $default-color-light-2
      .fund
        margin-bottom 1rem
        display flex
        padding 20px 20px
        flex-wrap wrap
        width 100%

        .fund-parent
          width: 50%
          align-self flex-start

        .fund-children
          width: 50%

        .fund-description
          width 100%
          margin-bottom 20px
          &:last-child
            margin-bottom 0

          .fund-type

            font-weight:bold
            color $default-color-bold-1

    .fund-block
      &:first-child
        .group-name
          margin-top 1rem
    .group-name
      color $default-color-bold
      font-weight 600
      margin 2rem 0 10px
      padding-bottom 10px
      border-bottom 3px solid $default-color-light-1

    .children
      display flex
      flex-direction column

      .ultimate-child
        margin-bottom 1rem

      .name
        color $default-color-bold
        font-weight 600
        margin-bottom 1rem

      .show-more
        &__btn
          font-weight 600

  @media (max-width: $laptop)
    .relationship-table
      .parents
        flex-direction column

        .parent
          line-height 1.8
</style>



// WEBPACK FOOTER //
// src/components/record-details/Relationships.vue